import { useTranslation } from 'react-i18next';
import { SummaryOthersProps } from '../../Summary.model';
import { SummaryArticle } from '../summary-article/SummaryArticle';
import { SummaryItem } from '../summary-item/SummaryItem';
import { SummarySubItem } from '../summary-sub-item/SummarySubItem';
import { memo } from 'react';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';

export const SummaryOthers = memo(
	function SummaryOthers({ otherItems }: SummaryOthersProps) {
		const { t } = useTranslation('summary');
		return (
			<ErrorBoundaryProvider>
				{otherItems?.map((item) => {
					let titleLiteral: ResourcesType<'summary'> | '' = '',
						totalLiteral: ResourcesType<'summary'> | '' = '';
					if (item.type !== 'ONHOLD' && item.type !== 'JOURNEY') {
						titleLiteral = `OTHER_ITEMS_${item.type}`;
						if (item.type !== 'OFFERS') {
							totalLiteral = `OTHER_ITEMS_TOTAL_${item.type}`;
						}
					}
					return (
						<SummaryItem
							key={item.type}
							title={t(titleLiteral as ResourcesType<'summary'>)}
							total={
								item.total
									? {
											title: t(totalLiteral as ResourcesType<'summary'>),
											price: item.total
										}
									: undefined
							}
						>
							<SummarySubItem text={item.subtitle} price={item.price}>
								{item.items?.map((item) => {
									return (
										<SummaryArticle
											amount={item.amount}
											key={item.code}
											text={item.description}
											price={item.price}
										></SummaryArticle>
									);
								})}
							</SummarySubItem>
						</SummaryItem>
					);
				})}
			</ErrorBoundaryProvider>
		);
	},
	(prev, next) => JSON.stringify(prev) === JSON.stringify(next)
);
SummaryOthers.displayName = 'SummaryOthers';
